import React from 'react';
import NumberFormat from '.';

export default function CepFormatComponent (props) {
  return <NumberFormat {...props} format="#####-###" mask="_" />;
};
